var render, staticRenderFns
import script from "./LoginSubmit.vue?vue&type=script&lang=js&"
export * from "./LoginSubmit.vue?vue&type=script&lang=js&"
import style0 from "./LoginSubmit.vue?vue&type=style&index=0&id=e8184f5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8184f5c",
  null
  
)

export default component.exports